import QuizzesList from './QuizzesList';
export default QuizzesList;